import * as React from "react";
import Popover from "@mui/material/Popover";
import Button from "@mui/material/Button";
import { CODES } from "../../consts/codes";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Avatar, Divider, Grid } from "@mui/material";
import { useNavigate } from "react-router";
import { LogoutService } from "../../services/auth/authServices";
import { useTranslation } from "react-i18next";
import jwt_decode from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../../pages/userSlice";
import LoginIcon from "@mui/icons-material/Login";
import SettingsIcon from "@mui/icons-material/Settings";
import { useEffect } from "react";
import { useState } from "react";
import {
  resetCurrentCompany,
  setCurrentCompany,
} from "../../parts/listUsers/listUsersSlice";

export default function ButtonLogOut() {
  const { t } = useTranslation();

  const [isDesktop, setDesktop] = useState(window.innerWidth > 768);

  const updateMedia = () => {
    setDesktop(window.innerWidth > 890);
  };
  const dispatch = useDispatch();

  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const userInfo = useSelector(getUser);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const navigate = useNavigate();
  const handleClose = () => {
    setAnchorEl(null);
  };

  const jwtTokenInfo = localStorage.getItem("infoToken");

  let role = "";
  if (jwtTokenInfo) {
    const jwtDecodeTokenInfo = jwt_decode(jwtTokenInfo);

    role = jwtDecodeTokenInfo["custom:Role"];
  }

  const handleLogOut = async () => {
    try {
      const service = await LogoutService();

      if (service.status === CODES.COD_RESPONSE_HTTP_OK) {
        if (
          service.data.responseCode === CODES.COD_RESPONSE_SUCCESS_REQUEST ||
          service.data.responseCode === CODES.COD_RESPONSE_HTTP_BAD_REQUEST
        ) {
          dispatch(resetCurrentCompany());
          sessionStorage.clear();
          localStorage.clear();

          navigate("/");
        }
      }
    } catch (error) {
      console.log("==============Error handleLogout======================");
      console.log(error);
      console.log("====================================");
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <Button
        disableRipple
        aria-describedby={id}
        variant="contained"
        onClick={handleClick}
        sx={{
          border: "none !important",
          boxShadow: "2px 2px 2px  #E0E0E066 !important",
        }}
      >
        <Grid container direction="row" spacing={1}>
          <Grid item className="col-flex">
            <Avatar sx={{ bgcolor: "#F0ECFF", color: "#553AB6", fontSize: 18 }}>
              {role === "admin"
                ? "A"
                : userInfo &&
                  userInfo.firstName &&
                  userInfo.lastName &&
                  `${userInfo.firstName[0]}${userInfo.lastName[0]}`}
            </Avatar>
          </Grid>
          {isDesktop ? (
            <Grid item className="col-flex">
              {role === "admin"
                ? t("App.roles.admin")
                : userInfo &&
                  userInfo.firstName &&
                  userInfo.lastName &&
                  `${userInfo.firstName} ${userInfo.lastName}`}
            </Grid>
          ) : (
            <></>
          )}
          <Grid item className="col-flex">
            <ExpandMoreIcon sx={{ fontSize: 20 }}></ExpandMoreIcon>
          </Grid>
        </Grid>
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        PaperProps={{
          style: {
            // minHeight: "205px",
            height: "max-content",
            borderRadius: "12px",
            marginTop: "0.5%",
            marginRight: "10% !important",
          },
        }}
      >
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
          spacing={1}
          className="logout_container"
          width={"100%"}
        >
          <Grid item>
            <p className="logout_container__textTitle">
              {role === "admin"
                ? t("App.roles.admin")
                : userInfo && userInfo.firstName + " " + userInfo.lastName}
            </p>
          </Grid>
          <Grid item>
            <p className="logout_container__text">
              {userInfo && userInfo.email}
            </p>
          </Grid>
          <Grid item>
            <p className="logout_container__text__two">
              {userInfo && userInfo.company && userInfo.company.companyName}
            </p>
          </Grid>
          <Grid
            item
            sx={{
              width: "100%",
              padding: "1%",
              marginTop: "2%",
              marginBottom: "2%",
            }}
          >
            <hr style={{ color: "#E0E0E0 !important" }} />
          </Grid>
          {/* <Grid item sx={{ marginLeft: "2.5px" }}>
            <Button
              className="btn__logout"
              startIcon={<SettingsIcon sx={{ color: "#553AB6" }} />}
            >
              {t("App.navBar.settings")}
            </Button>
          </Grid> */}
          <Grid item>
            <Button
              className="btn__logout"
              startIcon={<LoginIcon sx={{ color: "#553AB6" }} />}
              onClick={handleLogOut}
            >
              {t("App.navBar.logOut")}
            </Button>
          </Grid>
        </Grid>
      </Popover>
    </div>
  );
}
